module.exports = __webpack_public_path__ + "img/logo.17740c68.png";